var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"computedValue"},[_vm._v("实测最大值："+_vm._s(_vm.maxValue)+" - 实测最小值："+_vm._s(_vm.minValue)+" - 实测平均值："+_vm._s(_vm.avgValue))]),_c('div',{staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"eoc-record-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }